import {compose} from "redux";
import {connect} from "react-redux";
import ForgotAccount from "./ForgotAccount";
import {getAccess2Object} from "../../../globalState/user/actions";

let mapStateToProps = (state, props) => {
    return {
    }
};


export default compose(connect(mapStateToProps, {getAccess2Object}))(ForgotAccount);

